module.exports = __webpack_public_path__ + "img/vision_fondo.e6817f5f.png";